import {showHomeDataReview, showFeaturedDataReview, showEditorsDataReview} from "../../utils/shared"

let backgrounds = jsonData.home.backgrounds.list
/*
let vimeo = [
    'https://player.vimeo.com/external/347095741.hd.mp4?s=cce1a302a66776e34a84c93857e3ccff6b7bd741&profile_id=174',
    'https://player.vimeo.com/external/347092254.hd.mp4?s=1a5a289e7bddac1eb731af554877808390f38041&profile_id=174',
    'https://player.vimeo.com/external/347092241.hd.mp4?s=7079753c8ef1b18fdfbd8af4980f16ce29215331&profile_id=174',
    'https://player.vimeo.com/external/347092230.hd.mp4?s=f3d0fa48ac0d3921e32e25fd6e78310f6717d6e8&profile_id=174',
    'https://player.vimeo.com/external/346932525.hd.mp4?s=f2cef259fe76e93ab3f38fa70932ba9c9eebd5f8&profile_id=174',
    'https://player.vimeo.com/external/346932536.hd.mp4?s=3fcfbaa92bddbe885091b7fed49086bf1cc2239d&profile_id=174',
    'https://player.vimeo.com/external/346932529.hd.mp4?s=bc5a0901f28ac860bb9aad538fc0725ac60bb391&profile_id=174',
    'https://player.vimeo.com/external/346932547.hd.mp4?s=2092ea812133e00c48b00fe53d00406ba5efe4fa&profile_id=174',
    'https://player.vimeo.com/external/346932539.hd.mp4?s=6fc67e58a90e75409fc1e72775ad3e54f007e3f0&profile_id=174',
    'https://player.vimeo.com/external/346926221.hd.mp4?s=9c72c2adc6102ea1b0f4b7a0e009b36facb16940&profile_id=174',
    'https://player.vimeo.com/external/346926214.hd.mp4?s=c4d799315de2b01a2f3bccbb2d899ebc814c7a28&profile_id=174',
    'https://player.vimeo.com/external/346922947.hd.mp4?s=fe140623bb43edf12e94165d1960afe055f5ecf7&profile_id=174',
    'https://player.vimeo.com/external/346922959.hd.mp4?s=3ee1f587ea492525220533dff39fcdbd5602efe8&profile_id=174',
    'https://player.vimeo.com/external/334054994.hd.mp4?s=ce44258013462050157fac0a543f8c9198378890&profile_id=174',
    'https://player.vimeo.com/external/334054999.hd.mp4?s=c30728468cbe0cab03703820fc2b4f59d6fe2354&profile_id=174',
    'https://player.vimeo.com/external/334055015.hd.mp4?s=c0cbe2e9ecfb9c3d0f20cf1d836bf148f47000a9&profile_id=174',
    'https://player.vimeo.com/external/334449984.hd.mp4?s=cb2896c2f41c583be47349c0dc765c1a3e5a46ea&profile_id=174',
    'https://player.vimeo.com/external/334452174.hd.mp4?s=f66bd20f985384b63cf2fb1b03dccc541d16abb3&profile_id=174',
    'https://player.vimeo.com/external/334452265.hd.mp4?s=1337b32ef431d754f9c3e2cb67061ef172ea8b16&profile_id=174',
    'https://player.vimeo.com/external/334454340.hd.mp4?s=f7cb429b2f9add0dfe486983e28a281b4d71fbdd&profile_id=174',
    'https://player.vimeo.com/external/334452203.hd.mp4?s=d4ab0e81366ac6bb45d3bdedcd31e1d28878f9f2&profile_id=174',
    'https://player.vimeo.com/external/334452152.hd.mp4?s=087152e14bb3a445b3cda16f03ecec6aec704384&profile_id=174',
    'https://player.vimeo.com/external/334452284.hd.mp4?s=45ccaff809570e245e08a85dfa95ea2fc808a1c1&profile_id=174',
]


backgrounds = backgrounds.map((el, index) => {
    el.url = vimeo[index]

    return el
})
/**/

// initial state
const state = {
    backgrounds: backgrounds,
    home: null,
}

// show used data from wiredrive to analyze it (some fields can be empty, so it is fast solution to review them)
/*
showHomeDataReview(state.backgrounds)
showFeaturedDataReview(state.reels)
showEditorsDataReview(state.list)
*/

// getters
const getters = {
    _loaded: (state, getters) => getters.backgrounds.filter((home) => home._loaded),
    backgrounds: (state) => state.backgrounds,
    poster: (state) => (slide) => {
        return slide.thumbs.max.url
    },
    posterFallback: (state, getters, rootState, rootGetters) => (slide) => {
        return rootGetters['ui/canAutoplay']
            ? null
            : getters.poster(slide)
    },
}

// actions
const actions = {
    initHomeState({commit, dispatch, state}, params) {
        //console.log('initHomeState');
        //debugger
        dispatch('player/clean', params, {root: true})
        dispatch('initHome', params)
    },
    initHome({commit, state}, params) {
        //debugger

        //let shortHome = state.backgrounds.find((home) => home.shortVideo.description.toLowerCase() === params.detail.toLowerCase())
        let fullHome = state.backgrounds.find((home) => home.slug === params.detail)

        if (fullHome) {
            let fullHomes = state.backgrounds.map((home) => {
                return home
            })

            commit('setHome', fullHome)

            commit('player/setBack', '/', {root: true})
            commit('player/setList', fullHomes, {root: true})
            commit('player/setCurrent', fullHome, {root: true})
        }
    },
}

// mutations
const mutations = {
    setHome(state, home) {
        //debugger
        state.home = home
    },

    setLoadedBackground(state, slide) {
        //debugger
        Vue.set(slide, '_loaded', true)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
